<div class="side-bar">
  <div class="d-flex justify-content-between align-items-center pb-px-12">
    <mat-label class="fs-20 fw-7" *ngIf="title">{{ title }}</mat-label>
    <div class="d-flex align-items-center">
      <div class="w-fit-content me-2">
        <app-tag [label]="rowData?.statusOfCandidatOnMission | candidatMissionStatus" [type]="
            rowData?.statusOfCandidatOnMission | stausCandidatMissionColorEnums
          " class="{{
            (rowData?.statusOfCandidatOnMission | stausCandidatMissionColor) +
              ' fit-content ml-px-8'
          }}" customIcon="red-flag" [withIcon]="false"></app-tag>
      </div>
      <svg-icon (click)="onDialogClose()" src="/assets/icons/close-modal-primary.svg" class="cursor-pointer"></svg-icon>
    </div>
  </div>
<!--  <div class="py-px-24" *ngIf="rowData?.user">
    <app-text-separator text="Candidat"></app-text-separator>
  </div>
 <div class="card-container p-px-16 mb-px-24">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex flex-column">
        <app-user [text]="
            rowData?.user?.firstname + ' ' + rowData?.user?.lastname ||
            user?.fullname ||
            'N/A'
          " [imageSrc]="
            rowData?.user?.photo
              ? 'data:image/jpeg;base64,' + rowData?.user?.photo
              : ''
          "></app-user>
      </div>
      <div class="d-flex align-items-center">
        <app-button text="Voir profil" (click)="condidatProfil()" [stroked]="true" color="primary"
          class="me-1"></app-button>
        <app-button text="Voir le contrat" [stroked]="true"></app-button>
      </div>
    </div>
  </div>-->

  <div class="py-px-6">
    <app-text-separator text="Description"></app-text-separator>
    <p class="py-px-6 fs-13 fw-4">
      {{ rowData?.description }}
    </p>
    <div class="drop-photo-area py-px-6">
      <img [src]="'data:image/jpeg;base64,' + rowData?.photo1" *ngIf="rowData?.photo1" class="cursor-pointer" alt="photo1"
        (click)="openImage(rowData?.photo1)" />
      <img [src]="'data:image/jpeg;base64,' + rowData?.photo2" *ngIf="rowData?.photo2" class="cursor-pointer" alt="photo2"
        (click)="openImage(rowData?.photo2)" />
      <img [src]="'data:image/jpeg;base64,' + rowData?.photo3" *ngIf="rowData?.photo3" class="cursor-pointer" alt="photo3"
        (click)="openImage(rowData?.photo3)" />
      <img [src]="'data:image/jpeg;base64,' + rowData?.photo4" *ngIf="rowData?.photo4" class="cursor-pointer" alt="photo4"
        (click)="openImage(rowData?.photo4)" />
      <img [src]="'data:image/jpeg;base64,' + rowData?.photo5" *ngIf="rowData?.photo5" class="cursor-pointer" alt="photo5"
        (click)="openImage(rowData?.photo5)" />
    </div>
  </div>

  <div class="py-px-6">
    <app-text-separator text="Général"></app-text-separator>
    <div class="py-px-6 d-flex">
      <div class="d-flex flex-column align-items-start">
        <div class="d-flex my-px-12">
          <svg-icon src="/assets/icons/site-rounded.svg"></svg-icon>
          <div class="d-flex flex-column ms-3">
            <span class="fs-13 fw-4">Site</span>
            <span class="fs-16 fw-4">{{ rowData?.adresseDto?.name }}</span>
          </div>
        </div>
        <div class="d-flex my-px-12">
          <svg-icon src="/assets/icons/speciality-rounded.svg"></svg-icon>
          <div class="d-flex flex-column ms-3">
            <span class="fs-13 fw-4">Poste</span>
            <span class="fs-16 fw-4">{{ rowData?.typePoste }}</span>
          </div>
        </div>
        <div class="d-flex my-px-12">
          <svg-icon src="/assets/icons/file-text-rounded.svg"></svg-icon>
          <div class="d-flex flex-column ms-3">
            <span class="fs-13 fw-4">Contrat</span>
            <span class="fs-16 fw-4">{{
              rowData?.typecontat == "LIBERAL" ? "INTÉRIM" : rowData?.typecontat
              }}</span>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column align-items-start ms-4">
        <div class="d-flex my-px-12">
        <svg-icon src="/assets/icons/heart-beating-rounded.svg"></svg-icon>
        <div class="d-flex flex-column ms-3">
          <span class="fs-13 fw-4">Service d’affectation</span>
          <span class="fs-16 fw-4">{{
            rowData?.serviceAffectationsName ||
            rowData?.serviceAffectations ||
            "N/A"
            }}</span>
            </div>
        </div>
      <div class="d-flex my-px-12">
        <svg-icon src="/assets/icons/secteur-rounded.svg"></svg-icon>
        <div class="d-flex flex-column ms-3">
          <span class="fs-13 fw-4">Secteur</span>
          <span class="fs-16 fw-4">{{ rowData?.typeSecteur }}</span>
        </div>
      </div>
        <div class="d-flex my-px-12">
          <svg-icon src="/assets/icons/money-rounded.svg"></svg-icon>
          <div class="d-flex flex-column ms-3">
            <span class="fs-13 fw-4">Rémunération</span>
            <span class="fs-16 fw-4">{{ rowData?.compensationproposednet | number }} € /{{ rowData?.compensationType === 'HOUR' ? 'heure' : 'jour' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="py-px-6">
    <app-text-separator text="Date(s) et durée" textClass="w-px-140"></app-text-separator>
    <div class="py-px-6 d-flex justify-content-between">
      <div class="d-flex flex-column">
        <span class="fs-13 fw-3">Durée</span>
        <span class="fs-16 fw-4">{{ diffDays ? diffDays : 1 }} jour(s)</span>
      </div>
      <div class="d-flex flex-column">
        <span class="fs-13 fw-3">Début</span>
        <span class="fs-16 fw-4">{{ startDate }}</span>
      </div>
      <div class="d-flex flex-column">
        <span class="fs-13 fw-3">Fin</span>
        <span class="fs-16 fw-4">{{ endDate }}</span>
      </div>
    </div>
  </div>
  <div class="py-px-6 pb-px-100">
    @if(fichePosteFiles.length){
    <app-text-separator text="FICHE DE POSTE : APPUYER POUR VISUALISER" textClass="w-px-360"></app-text-separator>
    <app-upload-file class="my-px-12" (sendFile)="getFile($event, 'fichePostes')" [files]="fichePosteFiles"
      [required]="false" [isDeletable]="false"></app-upload-file>
    }
    <app-text-separator text="Prise en charge des frais de mission" textClass="w-px-316"></app-text-separator>
    <div class="">
      <div class="py-px-6">
        <div class="d-flex gap-1 mb-px-12" *ngIf="rowData?.isaccommodationprovidedbyestablishment">
          <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
          <div class="d-flex flex-column">
            <span class="fs-16 fw-4">Hébergement</span>
            @if(rowData?.isaccommodationprovidedfromexterior)
            {
            <span>{{'Extérieur (Hôtel ou location) : '}} {{rowData?.accommodationconditions}}</span>
            }
            @else {
            <span>{{'Au sein de l’établissement : '}} {{rowData?.accommodationconditions}}</span>
            }
  
          </div>
  
        </div>
        <div class="d-flex gap-1 mb-px-12" *ngIf="rowData?.ismealsprovidedbyestablishment">
          <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
          <div class="d-flex flex-column">
            <span class="fs-16 fw-4">Repas</span>
            @if(rowData?.ismealsprovidedfromexterior)
            {
            <span>{{'Extérieur (Hôtel ou location) : '}} {{rowData?.mealsconditions}}</span>
            }
            @else {
            <span>{{'Au sein de l’établissement : '}} {{rowData?.mealconditions}}</span>
            }
          </div>
        </div>
        <div class="d-flex gap-1 mb-px-12" *ngIf="rowData?.istakinginchargetravelingexpenses">
          <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
          <div class="d-flex flex-column">
            <span class="fs-16 fw-4">Frais de déplacement</span>
            <span>{{rowData?.travelingconditions}}</span>
          </div>
        </div>
        <div class="d-flex gap-1 mb-px-12" *ngIf="rowData?.isprimeprovided">
          <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
          <div class="d-flex flex-column">
            <span class="fs-16 fw-4">Prime d’installation</span>
            <span>{{rowData?.otherprimesconditions}}</span>
          </div>
        </div>
        <div class="d-flex gap-1 mb-px-12" *ngIf="rowData?.isthirteenthmonthprovided">
          <svg-icon src="/assets/icons/check-success.svg"></svg-icon>
          <span class="fs-16 fw-4">Treizième mois</span>
        </div>
      </div>
    </div>
  </div>
</div>